import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReleasesStats } from 'services/api/entities';
import { StatisticsContainer, StatContainer, StatName } from './styled';

interface PropsType {
  stats: ReleasesStats;
}

const Statistics = ({ stats }: PropsType) => {
  const { t } = useTranslation();
  return (
    <StatisticsContainer>
      <StatContainer>
        <Typography variant="h3">{stats.released}</Typography>
        <StatName>{t('distribution:releasesStats:name:released')}</StatName>
      </StatContainer>
      <StatContainer>
        <Typography variant="h3">{stats.pending}</Typography>
        <StatName>{t('distribution:releasesStats:name:pending')}</StatName>
      </StatContainer>
      <StatContainer>
        <Typography variant="h3">{stats.draft}</Typography>
        <StatName>{t('distribution:releasesStats:name:draft')}</StatName>
      </StatContainer>
    </StatisticsContainer>
  );
};

export default Statistics;
